export default "__VITE_ASSET__DfHVg3Eu__"